<template>
  <div>
    <el-checkbox-group
      ref="checkbox"
      v-model="v_value"
      :size="size"
      :disabled="disabled"
      @change="change($event)"
    >
      <el-checkbox
        v-for="option in optionData"
        :key="option.value"
        :label="option.value"
      >
        {{ option.label }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import { request } from '@/api/service'
import lodash, { cloneDeep } from 'lodash'

export default {
  name: 'DictCheckbox',
  props: {
    checkList: {
      type: Array,
      default: () => [],
    }, // 接受外部v-model传入的值，要支持多选，不能指定字段类型和默认值
    size: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '/master/common/dict/system',
    },
    body: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
    method: {
      type: String,
      default: 'POST',
    },
    options: {
      type: Object,
      default: () => ({ label: 'label', value: 'value' }),
    },
    cache: {
      type: Boolean,
      default: true,
    },
    valueSeparator: {
      type: String,
      default: ',',
    },
    labelSeparator: {
      type: String,
      default: '、',
    },
    itemsTransform: {
      type: Function,
    },
  },
  data() {
    return {
      v_value: [],
      label: [],
      items: [],
      valueString: '',
      labelString: '',
      optionData: [],
    }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.optionData.map((o) => [o.value, o]))
    },
    reuqestParams() {
      return {
        body: this.body,
        params: this.params,
        url: this.url,
      }
    },
  },
  watch: {
    reuqestParams: {
      deep: true,
      handler() {
        this.init()
      },
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      if (!this.url) return
      this.v_value = cloneDeep(this.checkList)
      const data = await request({
        url: this.url,
        method: this.method,
        data: this.body,
        params: this.params,
        cache: this.cache,
      })
        .then((res) => res.body?.data || [])
        .catch(() => [])

      const _items = this._dataTransform(data)
      this.optionData = this.itemsTransform
        ? this.itemsTransform(_items)
        : _items

      this.$emit('loaded', data)
    },
    change(val) {
      const _items = lodash.map(val, (v) => this.optionsMap[v])
      const _label = lodash.map(_items, 'label')
      const _valueString = lodash.join(val, this.valueSeparator)
      const _labelString = lodash.join(_label, this.labelSeparator)

      this.$emit('change', val, _label, {
        items: _items,
        value: val,
        label: _label,
        valueString: _valueString,
        labelString: _labelString,
      })

      this.label = _label
      this.items = _items
      this.valueString = _valueString
      this.labelString = _labelString
    },
    _dataTransform(data) {
      if (!this.options) return data
      if (!data.length) return []

      return data.map((t) => {
        const { label, value } = this.options
        return {
          label: t[label || 'label'],
          value: value === 'this' ? t : t[value],
        }
      })
    },
  },
}
</script>
